export const playerPositionOptions = (t: any) => {
	return [
		{ value: 'keeper', label: t('goalkeeper') },
		{ value: 'forward', label: t('forward') },
		{ value: 'midfielder', label: t('midfielder') },
		{ value: 'defender', label: t('defender') },
	];
};
